import React from 'react';

const SelectRectangleBlock = ({isActive = false, ...props}) => {
    return (
        <div className={`select-rectangle-block ${isActive ? 'active' : ''}`} {...props}>
            <div className={`inside-block`}>
                {props.children}
            </div>
        </div>
    )
};

export default SelectRectangleBlock;